export default __webpack_public_path__ + "static/media/yacht.41f571d5.jpg";